import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Unauthorized = () => {
  const { currentUser } = useAuth();
  
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow">
            <div className="card-body p-5 text-center">
              <div className="mb-4">
                <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: '4rem' }}></i>
              </div>
              
              <h2 className="mb-4">Access Denied</h2>
              
              <p className="lead mb-4">
                You don't have permission to access this resource.
              </p>
              
              {currentUser && (
                <div className="alert alert-info">
                  <p className="mb-0">
                    <strong>Current Role:</strong> {currentUser.role}
                  </p>
                </div>
              )}
              
              <div className="mt-4">
                <Link to="/" className="btn btn-primary">
                  Return to Dashboard
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
